module.exports = __webpack_public_path__ + "img/12.bae29397.jpg";